import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Container } from '@material-ui/core';
import Section from '../components/Section';
import Header from '../components/Header';
import Jumbotron from '../components/Jumbotron';
import Banner from '../components/Banner';
import Title from '../components/Title';
import OutlinedButton from '../components/OutlinedButton';
import PostSlider from '../components/PostSlider';
import PostGroup from '../components/PostGroup';
import PostList from '../components/PostList';
import PreFooter from '../components/PreFooter';
import Footer from '../components/Footer';
import VideoPlayer from '../components/VideoPlayer';

import { convertDocsToPosts, fetchPosts } from '../services/posts';
import { auth } from '../services/firebase';
import HomeDialog from '../components/HomeDialog';

interface INewestPosts {
  events: Post[];
  articles: Post[];
  videos: Post[];
}
const initialVideoState = { open: false, url: '' };
const eventLength = 5;
const articleLength = 5;
const videoLength = 8;
const Home = () => {
  const history = useHistory();
  const [initLoading, setInitLoading] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(0);
  const [newestPosts, setNewestPosts] = useState<INewestPosts>();
  const [videoState, setVideoState] = useState<IVideoState>(initialVideoState);
  useEffect(() => {
    const fetchData = async () => {
      const [eventData, articleData, videoData] = await Promise.all([
        fetchPosts('event', eventLength),
        fetchPosts('article', articleLength),
        fetchPosts('video', videoLength),
      ]);
      setNewestPosts({
        events: convertDocsToPosts(eventData.docs),
        articles: convertDocsToPosts(articleData.docs),
        videos: convertDocsToPosts(videoData.docs),
      });
      setInitLoading(false);
    };
    fetchData();
  }, []);
  return (
    <>
      <Header />
      <Container maxWidth='md'>
        <VideoPlayer
          open={videoState.open}
          url={videoState.url}
          onClose={() => setVideoState((state) => ({ ...state, open: false }))}
        />
        <Section>
          <Box height={16} />
          <Jumbotron loggedIn={auth.currentUser !== null} />
          <Box height={16} />
        </Section>
        <Banner onButtonClick={() => history.push('/game')} />
        <Section>
          <Title
            title='กิจกรรม'
            subtitle='ติดตามข้อมูลข่าวสารเกี่ยวกับความมั่นคงปลอดภัย'
            align='center'
          />
          <Box height={32} />
          {newestPosts && (
            <PostSlider
              posts={newestPosts?.events}
              selectedIndex={selectedEvent}
              imageHeight={250}
              sideBySide
              onPageClick={(index) => setSelectedEvent(index)}
              type='event'
            />
          )}
          <Box height={32} />
          <Box display='flex' justifyContent='center'>
            <OutlinedButton onClick={() => history.push('/event')}>
              กิจกรรมทั้งหมด
            </OutlinedButton>
          </Box>
        </Section>
        <Section>
          <Title
            title='บทความ'
            subtitle='รู้หรือไม่? โลกออนไลน์ไม่น่ากลัวอย่างที่คิด อ่านบทความเพิ่มเติมความรู้ เสริมเกราะป้องกันอันตรายจากโลกไซเบอร์ได้ที่นี่'
            align='center'
          />
          <Box height={32} />
          {newestPosts && (
            <PostGroup
              posts={newestPosts?.articles}
              featuredSize={6}
              postColumn={2}
              type='article'
            />
          )}
          <Box height={32} />
          <Box display='flex' justifyContent='center'>
            <OutlinedButton onClick={() => history.push('/article')}>
              ดูบทความทั้งหมด
            </OutlinedButton>
          </Box>
        </Section>
        <Section>
          <Title
            title='วิดีโอ'
            subtitle='รู้จัก Cyber Security ให้ดีขึ้น ด้วยวิดีโอสั้น'
            align='center'
          />
          <Box height={32} />
          {newestPosts && (
            <PostList
              posts={newestPosts?.videos}
              column={4}
              hideDetail
              type='video'
              onClickVideo={(url) =>
                setVideoState((state) => ({ ...state, url, open: true }))
              }
              loading={initLoading}
            />
          )}
          <Box height={32} />
          <Box display='flex' justifyContent='center'>
            <OutlinedButton onClick={() => history.push('/video')}>
              ดูวิดีโอทั้งหมด
            </OutlinedButton>
          </Box>
        </Section>
      </Container>
      <PreFooter />
      <Footer />
      <HomeDialog />
    </>
  );
};

export default Home;
